/*@flow*/

export default {
  version: 9,
  selectedMetrics: [
    'us-median-household-income-widget',
    'building-permit-applications-filed-widget',
  ],
  placeMetricsOrder: ([]: Array<any>),
  me: {
    id: null,
    company: {
      id: null,
      placeMetrics: [
        {
          id: 'hoboken-parcels-widget',
          description: 'Hoboken',
          name: 'Number of Parcels',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'cartodb_id',
            operation: 'count',
          },
          analysis: {
            id: 'hoboken_parcels_2018-analysis',
            table: 'hoboken_parcels_2018',
            sql: `
              SELECT
                cartodb_id,
                the_geom,
                the_geom_webmercator
              FROM hoboken_parcels_2018
            `,
          },
        },
        {
          id: 'bridgeport-parcels-widget',
          description: 'Bridgeport',
          name: 'Number of Parcels',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'cartodb_id',
            operation: 'count',
          },
          analysis: {
            id: 'bridgeport_parcels-analysis',
            table: 'bridgeport_parcels',
            sql: `
              SELECT
                cartodb_id,
                the_geom,
                the_geom_webmercator
              FROM bridgeport_parcels
            `,
          },
        },
        {
          id: 'nyc-parcels-widget',
          name: 'Number of Parcels',
          description: 'New York City',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'cartodb_id',
            operation: 'count',
          },
          analysis: {
            id: 'mappluto-analysis',
            table: 'mappluto',
            sql: `
              SELECT
                cartodb_id,
                unitsres,
                numbldgs,
                bldgarea,
                the_geom,
                the_geom_webmercator
              FROM mappluto
            `,
          },
        },
        {
          id: 'building-permit-applications-filed-widget',
          name: 'Building Permit Applications Filed',
          source: 'NYC Department of Buildings (2015 to present)',
          description: 'New York City',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'cartodb_id',
            operation: 'count',
          },
          analysis: {
            id: 'building-permit-analysis',
            table: 'dob_job_application_filings_merge',
            sql: `
              SELECT
                cartodb_id,
                proposed_dwelling_units,
                proposed_zoning_sqft,
                the_geom,
                the_geom_webmercator
              FROM dob_job_application_filings_merge
            `,
          },
        },
        {
          id: 'nyc-proposed-dwelling-widget',
          name: 'Proposed Dwelling Units (Avg.)',
          source: 'NYC Department of Buildings (2013 to present)',
          description: 'New York City',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'proposed_dwelling_units',
            operation: 'avg',
          },
          analysis: {
            id: 'building-permit-analysis',
            table: 'dob_job_application_filings_merge',
            sql: `
              SELECT
                cartodb_id,
                proposed_dwelling_units,
                proposed_zoning_sqft,
                the_geom,
                the_geom_webmercator
              FROM dob_job_application_filings_merge
            `,
          },
        },
        {
          id: 'us-median-household-income-widget',
          name: 'Median Household Income',
          source: 'Census Tract and 2014 ACS data',
          prefix: '$',
          description: 'US',
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'median_income',
            operation: 'avg',
          },
          analysis: {
            id: 'employment-analysis',
            sql: `
              SELECT
                the_geom,
                the_geom_webmercator,
                ACS_14_5YR_DP03_HC01_VC85 as median_income
              FROM acs_14_5yr_dp03
            `,
            table: 'acs_14_5yr_dp03',
          },
        },
        {
          id: 'nyc-existing-housing-units-widget',
          name: 'Existing Housing Units',
          source: 'NYC Department of Finance',
          description: 'New York City',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'unitsres',
            operation: 'sum',
          },
          analysis: {
            id: 'mappluto-analysis',
            table: 'mappluto',
            sql: `
              SELECT
                cartodb_id,
                unitsres,
                numbldgs,
                bldgarea,
                the_geom,
                the_geom_webmercator
              FROM mappluto
            `,
          },
        },
        {
          id: 'nyc-buildings-widget',
          name: 'Buildings',
          source: 'NYC Department of Finance',
          description: 'New York City',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'numbldgs',
            operation: 'sum',
          },
          analysis: {
            id: 'mappluto-analysis',
            table: 'mappluto',
            sql: `
              SELECT
                cartodb_id,
                unitsres,
                numbldgs,
                bldgarea,
                the_geom,
                the_geom_webmercator
              FROM mappluto
            `,
          },
        },
        {
          id: 'nyc-avg-building-area-widget',
          name: 'Avg Building Floor Area',
          source: 'NYC Department of Finance',
          postfix: ' sq ft',
          description: 'New York City',
          prefix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'bldgarea',
            operation: 'avg',
          },
          analysis: {
            id: 'mappluto-analysis',
            table: 'mappluto',
            sql: `
              SELECT
                cartodb_id,
                unitsres,
                numbldgs,
                bldgarea,
                the_geom,
                the_geom_webmercator
              FROM mappluto
            `,
          },
        },
        {
          id: 'property_information',
          name: 'Number of Parcels',
          description: 'City of Baltimore',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'cartodb_id',
            operation: 'count',
          },
          analysis: {
            id: 'baltimore_parcels-analysis',
            table: 'property_information',
            sql:
              'SELECT cartodb_id, the_geom, the_geom_webmercator FROM property_information',
          },
        },
        {
          id: 'parcels_10',
          name: 'Total Population from 2015 ACS',
          description: 'Based on Census Block Groups',
          prefix: null,
          postfix: null,
          valueFormula: null,
          custom: false,
          dataview: {
            column: 'total_pop',
            operation: 'sum',
          },
          analysis: {
            id: '2015 American Community Survey-analysis',
            table: 'us_census_block_groups',
            sql:
              'SELECT cartodb_id, the_geom, the_geom_webmercator FROM us_census_block_groups',
          },
        },
      ],
      placeMetricAnalyses: [
        {
          id: 1,
          name: 'Hoboken Parcels',
          table: 'hoboken_parcels_2018',
          fields: [
            { name: 'cartodb_id', label: 'id' },
            { name: 'addlc', label: 'addlc' },
            { name: 'bldgheight', label: 'bldgheight' },
            { name: 'block_12', label: 'block_12' },
            { name: 'cacres', label: 'cacres' },
            { name: 'landuse1', label: 'landuse1' },
            { name: 'lot_12', label: 'lot_12' },
            { name: 'sqft', label: 'sqft' },
          ],
        },
        {
          id: 2,
          name: 'NYC Parcels',
          table: 'mappluto',
          fields: [
            { name: 'cartodb_id', label: 'id' },
            { name: 'assessland', label: 'assessland' },
            { name: 'assesstot', label: 'assesstot' },
            { name: 'bldgarea', label: 'bldgarea' },
            { name: 'bldgdepth', label: 'bldgdepth' },
            { name: 'bldgfront', label: 'bldgfront' },
            { name: 'borocode', label: 'borocode' },
            { name: 'builtfar', label: 'builtfar' },
            { name: 'comarea', label: 'comarea' },
            { name: 'commfar', label: 'commfar' },
            { name: 'exemptland', label: 'exemptland' },
            { name: 'exempttot', label: 'exempttot' },
            { name: 'facilfar', label: 'facilfar' },
            { name: 'factryarea', label: 'factryarea' },
            { name: 'garagearea', label: 'garagearea' },
            { name: 'healtharea', label: 'healtharea' },
            { name: 'healthcent', label: 'healthcent' },
            { name: 'lotarea', label: 'lotarea' },
            { name: 'lotdepth', label: 'lotdepth' },
            { name: 'lotfront', label: 'lotfront' },
            { name: 'numbldgs', label: 'numbldgs' },
            { name: 'numfloors', label: 'numfloors' },
            { name: 'officearea', label: 'officearea' },
            { name: 'otherarea', label: 'otherarea' },
            { name: 'policeprct', label: 'policeprct' },
            { name: 'resarea', label: 'resarea' },
            { name: 'residfar', label: 'residfar' },
            { name: 'retailarea', label: 'retailarea' },
            { name: 'unitsres', label: 'unitsres' },
            { name: 'unitstotal', label: 'unitstotal' },
          ],
        },
        {
          id: 3,
          name: 'Building Permits',
          table: 'dob_job_application_filings_merge',
          fields: [{ name: 'cartodb_id', label: 'id' }],
        },
        {
          id: 4,
          name: 'NY Employment (2014 Census)',
          table: 'acs_14_5yr_dp03',
          fields: [{ name: 'cartodb_id', label: 'id' }],
        },
        {
          id: 5,
          name: 'Bridgeport Parcels',
          table: 'bridgeport_parcels',
          fields: [
            { name: 'cartodb_id', label: 'id' },
            { name: 'landval', label: 'landval' },
            { name: 'bldgval', label: 'bldgval' },
            { name: 'totval', label: 'totval' },
          ],
        },
        {
          id: 6,
          name: 'Toronto Parcels',
          table: 'property_boundaries_wgs84',
          fields: [{ name: 'cartodb_id', label: 'id' }],
        },
        {
          id: 7,
          name: 'Reno Parcels',
          table: 'reno_parcels',
          fields: [
            { name: 'cartodb_id', label: 'id' },
            { name: 'buildass', label: 'buildass' },
            { name: 'landapr', label: 'landapr' },
            { name: 'landass', label: 'landass' },
            { name: 'saleprice', label: 'saleprice' },
            { name: 'totalass', label: 'totalass' },
            { name: 'totalapr', label: 'totalapr' },
            { name: 'taxvalue', label: 'taxvalue' },
            { name: 'grosstax', label: 'grosstax' },
            { name: 'nettax', label: 'nettax' },
            { name: 'secured', label: 'secured' },
            { name: 'exempt', label: 'exempt' },
            { name: 'abate', label: 'abate' },
            { name: 'sqfeet', label: 'sqfeet' },
            { name: 'saleprice', label: 'saleprice' },
            { name: 'depreciati', label: 'depreciati' },
            { name: 'buildapr', label: 'buildapr' },
            { name: 'yearblt', label: 'yearblt' },
            { name: 'baths', label: 'baths' },
            { name: 'bedrooms', label: 'bedrooms' },
            { name: 'acreage', label: 'acreage' },
          ],
        },
        {
          id: 8,
          name: 'San Francisco Parcels',
          table: 'parcels_active_and_retired',
          fields: [{ name: 'cartodb_id', label: 'id' }],
        },
        {
          id: 9,
          name: 'Baltimore Property Data',
          table: 'property_information',
          fields: [
            { name: 'cartodb_id', label: 'id' },
            { name: 'taxbase', label: 'taxbase' },
            { name: 'bfcvland', label: 'bfcvland' },
            { name: 'bfcvimpr', label: 'bfcvimpr' },
            { name: 'landexmp', label: 'landexmp' },
            { name: 'imprexmp', label: 'imprexmp' },
            { name: 'citycred', label: 'citycred' },
            { name: 'statcred', label: 'statcred' },
            { name: 'ccredamt', label: 'ccredamt' },
            { name: 'currimpr', label: 'currimpr' },
            { name: 'currland', label: 'currland' },
            { name: 'exmpland', label: 'exmpland' },
            { name: 'artaxbas', label: 'artaxbas' },
            { name: 'statetax', label: 'statetax' },
            { name: 'city_tax', label: 'city_tax' },
            { name: 'dwelunit', label: 'dwelunit' },
            { name: 'roomunit', label: 'roomunit' },
            { name: 'salepric', label: 'salepric' },
            { name: 'year_build', label: 'year_build' },
            { name: 'structarea', label: 'structarea' },
            { name: 'grndrent', label: 'grndrent' },
            { name: 'shape_starea', label: 'shape_starea' },
            { name: 'shape_stlegth', label: 'shape_stlegth' },
          ],
        },
        {
          id: 10,
          name: '2015 American Community Survey',
          table:
            'usa_acs_demographics_sociodemographics_usa_blockgroup_2015_5yrs',
          fields: [
            { name: 'Total Population', label: 'total_pop' },
            { name: 'Total Households', label: 'households' },
            { name: 'Male Population', label: 'male_pop' },
            { name: 'Female Population', label: 'female_pop' },
            { name: 'Median Age', label: 'median_age' },
            { name: 'Male under 5 years', label: 'male_under_5' },
            { name: 'Male age 5 to 9', label: 'male_5_to_9' },
            { name: 'Male age 10 to 14', label: 'male_10_to_14' },
            { name: 'Male age 15 to 17', label: 'male_15_to_17' },
            { name: 'Male age 18 and 19', label: 'male_18_to_19' },
            { name: 'Male age 20', label: 'male_20' },
            { name: 'Male age 21', label: 'male_21' },
            { name: 'Male age 22 to 24', label: 'male_22_to_24' },
            { name: 'Male age 25 to 29', label: 'male_25_to_29' },
            { name: 'Male age 30 to 34', label: 'male_30_to_34' },
            { name: 'Male age 35 to 39', label: 'male_35_to_39' },
            { name: 'Male age 40 to 44', label: 'male_40_to_44' },
            { name: 'Men age 45 to 49', label: 'male_45_to_49' },
            { name: 'Men age 50 to 54', label: 'male_50_to_54' },
            { name: 'Men age 55 to 59', label: 'male_55_to_59' },
            { name: 'Men age 60 to 61', label: 'male_60_to_61' },
            { name: 'Men age 62 to 64', label: 'male_62_to_64' },
            { name: 'Male age 65 to 66', label: 'male_65_to_66' },
            { name: 'Male age 67 to 69', label: 'male_67_to_69' },
            { name: 'Male age 70 to 74', label: 'male_70_to_74' },
            { name: 'Male age 75 to 79', label: 'male_75_to_79' },
            { name: 'Male age 80 to 84', label: 'male_80_to_84' },
            { name: 'Male age 85 and over', label: 'male_85_and_over' },
            { name: 'Female under 5 years', label: 'female_under_5' },
            { name: 'Female age 5 to 9', label: 'female_5_to_9' },
            { name: 'Female age 10 to 14', label: 'female_10_to_14' },
            { name: 'Female age 15 to 17', label: 'female_15_to_17' },
            { name: 'Female age 18 and 19', label: 'female_18_to_19' },
            { name: 'Female age 20', label: 'female_20' },
            { name: 'Female age 21', label: 'female_21' },
            { name: 'Female age 22 to 24', label: 'female_22_to_24' },
            { name: 'Female age 25 to 29', label: 'female_25_to_29' },
            { name: 'Female age 30 to 34', label: 'female_30_to_34' },
            { name: 'Female age 35 to 39', label: 'female_35_to_39' },
            { name: 'Female age 40 to 44', label: 'female_40_to_44' },
            { name: 'Female age 45 to 49', label: 'female_45_to_49' },
            { name: 'Female age 50 to 54', label: 'female_50_to_54' },
            { name: 'Female age 55 to 59', label: 'female_55_to_59' },
            { name: 'Female age 60 and 61', label: 'female_60_to_61' },
            { name: 'Female age 62 to 64', label: 'female_62_to_64' },
            { name: 'Female age 65 to 66', label: 'female_65_to_66' },
            { name: 'Female age 67 to 69', label: 'female_67_to_69' },
            { name: 'Female age 70 to 74', label: 'female_70_to_74' },
            { name: 'Female age 75 to 79', label: 'female_75_to_79' },
            { name: 'Female age 80 to 84', label: 'female_80_to_84' },
            { name: 'Female age 85 and over', label: 'female_85_and_over' },
            { name: 'White Population', label: 'white_pop' },
            { name: 'Population age 16 and over', label: 'pop_16_over' },
            {
              name: 'Population 25 Years and Over',
              label: 'pop_25_years_over',
            },
            {
              name: 'Black or African American Population',
              label: 'black_pop',
            },
            { name: 'Asian Population', label: 'asian_pop' },
            { name: 'Hispanic Population', label: 'hispanic_pop' },
            {
              name: 'American Indian and Alaska Native Population',
              label: 'amerindian_pop',
            },
            { name: 'Other Race population', label: 'other_race_pop' },
            {
              name: 'Two or more races population',
              label: 'two_or_more_races_pop',
            },
            {
              name: 'White including Hispanic',
              label: 'white_including_hispanic',
            },
            {
              name: 'Black including Hispanic',
              label: 'black_including_hispanic',
            },
            {
              name: 'Asian including Hispanic',
              label: 'asian_including_hispanic',
            },
            {
              name:
                'American Indian and Alaska Native Population, including Hispanic',
              label: 'amerindian_including_hispanic',
            },
            { name: 'Population not Hispanic', label: 'not_hispanic_pop' },
            {
              name: 'Median Household Income in the past 12 Months',
              label: 'median_income',
            },
            {
              name: 'Per Capita Income in the past 12 Months',
              label: 'income_per_capita',
            },
            {
              name: 'Households with income less than $10,000',
              label: 'income_less_10000',
            },
            {
              name: 'Households with income of $10,000 to $14,999',
              label: 'income_10000_14999',
            },
            {
              name: 'Households with income of $15,000 to $19,999',
              label: 'income_15000_19999',
            },
            {
              name: 'Households with income of $20,000 to $24,999',
              label: 'income_20000_24999',
            },
            {
              name: 'Households with income of $25,000 to $29,999',
              label: 'income_25000_29999',
            },
            {
              name: 'Households with income of $30,000 to $34,999',
              label: 'income_30000_34999',
            },
            {
              name: 'Households with income of $35,000 to $39,999',
              label: 'income_35000_39999',
            },
            {
              name: 'Households with income of $40,000 to $44,999',
              label: 'income_40000_44999',
            },
            {
              name: 'Households with income of $45,000 to $49,999',
              label: 'income_45000_49999',
            },
            {
              name: 'Households with income of $50,000 to $59,999',
              label: 'income_50000_59999',
            },
            {
              name: 'Households with income of $60,000 to $74,999',
              label: 'income_60000_74999',
            },
            {
              name: 'Households with income of $75,000 to $99,999',
              label: 'income_75000_99999',
            },
            {
              name: 'Households with income of $100,000 to $124,999',
              label: 'income_100000_124999',
            },
            {
              name: 'Households with income of $125,000 to $149,999',
              label: 'income_125000_149999',
            },
            {
              name: 'Households with income of $150,000 to $199,999',
              label: 'income_150000_199999',
            },
            {
              name: 'Households with income of $200,000 Or More',
              label: 'income_200000_or_more',
            },
            {
              name: 'Households receiving retirement income',
              label: 'households_retirement_income',
            },
            { name: 'Housing Units', label: 'housing_units' },
            {
              name:
                'Renter-Occupied Housing Units Paying Cash Rent Median Gross Rent',
              label:
                'renter_occupied_housing_units_paying_cash_median_gross_rent',
            },
            {
              name: 'Owner-Occupied Housing Units Lower Value Quartile',
              label: 'owner_occupied_housing_units_lower_value_quartile',
            },
            {
              name: 'Owner-Occupied Housing Units Median Value',
              label: 'owner_occupied_housing_units_median_value',
            },
            {
              name: 'Owner-Occupied Housing Units Upper Value Quartile',
              label: 'owner_occupied_housing_units_upper_value_quartile',
            },
            { name: 'Occupied housing units', label: 'occupied_housing_units' },
            {
              name: 'Renter occupied housing units',
              label: 'housing_units_renter_occupied',
            },
            { name: 'Vacant Housing Units', label: 'vacant_housing_units' },
            {
              name: 'Vacant Housing Units for Rent',
              label: 'vacant_housing_units_for_rent',
            },
            {
              name: 'Vacant Housing Units for Sale',
              label: 'vacant_housing_units_for_sale',
            },
            {
              name: 'Single-family (one unit) detached dwellings',
              label: 'dwellings_1_units_detached',
            },
            {
              name: 'Single-family (one unit) attached dwellings',
              label: 'dwellings_1_units_attached',
            },
            {
              name: 'Two-family (two unit) dwellings',
              label: 'dwellings_2_units',
            },
            {
              name: 'Multifamily dwellings with three to 4 units',
              label: 'dwellings_3_to_4_units',
            },
            {
              name: 'Apartment buildings with 5 to 9 units',
              label: 'dwellings_5_to_9_units',
            },
            {
              name: 'Apartment buildings with 10 to 19 units',
              label: 'dwellings_10_to_19_units',
            },
            {
              name: 'Apartment buildings with 20 to 49 units',
              label: 'dwellings_20_to_49_units',
            },
            {
              name: 'Apartment buildings with 50 or more units',
              label: 'dwellings_50_or_more_units',
            },
            { name: 'Mobile homes', label: 'mobile_homes' },
            {
              name: 'Housing units built in 2005 or later',
              label: 'housing_built_2005_or_later',
            },
            {
              name: 'Housing units built between 2000 and 2004',
              label: 'housing_built_2000_to_2004',
            },
            {
              name: 'Housing units built before 1939',
              label: 'housing_built_1939_or_earlier',
            },
            {
              name: 'Median Year Structure Built',
              label: 'median_year_structure_built',
            },
            { name: 'Married households', label: 'married_households' },
            { name: 'Nonfamily Households', label: 'nonfamily_households' },
            { name: 'Family Households', label: 'family_households' },
            { name: 'Median Rent', label: 'median_rent' },
            {
              name: 'Percent of Household Income Spent on Rent',
              label: 'percent_income_spent_on_rent',
            },
            {
              name: 'Housing units without rent burden computed',
              label: 'rent_burden_not_computed',
            },
            {
              name: 'Housing units spending over 50% income on rent',
              label: 'rent_over_50_percent',
            },
            {
              name: 'Housing units spending 40 to 49',
              label: 'rent_40_to_50_percent',
            },
            {
              name: 'Housing units spending 35 to 39',
              label: 'rent_35_to_40_percent',
            },
            {
              name: 'Housing units spending 30 to 34',
              label: 'rent_30_to_35_percent',
            },
            {
              name: 'Housing units spending 25 to 29',
              label: 'rent_25_to_30_percent',
            },
            {
              name: 'Housing units spending 20 to 24',
              label: 'rent_20_to_25_percent',
            },
            {
              name: 'Housing units spending 15 to 19',
              label: 'rent_15_to_20_percent',
            },
            {
              name: 'Housing units spending 10 to 14',
              label: 'rent_10_to_15_percent',
            },
            {
              name: 'Housing units spending less than 10% on rent',
              label: 'rent_under_10_percent',
            },
            {
              name: 'Owner-occupied Housing Units',
              label: 'owner_occupied_housing_units',
            },
            {
              name: 'Owner-occupied Housing Units valued at $1,000,000 or more',
              label: 'million_dollar_housing_units',
            },
            {
              name: 'Owner-occupied Housing Units with a Mortgage',
              label: 'mortgaged_housing_units',
            },
            {
              name: 'Families with young children (under 6 years of age)',
              label: 'families_with_young_children',
            },
            {
              name:
                'Two-parent families with young children (under 6 years of age)',
              label: 'two_parent_families_with_young_children',
            },
            {
              name:
                'Two-parent families, both parents in labor force with young children (under 6 years of age)',
              label: 'two_parents_in_labor_force_families_with_young_children',
            },
            {
              name:
                'Two-parent families, father only in labor force with young children (under 6 years of age)',
              label:
                'two_parents_father_in_labor_force_families_with_young_children',
            },
            {
              name:
                'Two-parent families, mother only in labor force with young children (under 6 years of age)',
              label:
                'two_parents_mother_in_labor_force_families_with_young_children',
            },
            {
              name:
                'Two-parent families, neither parent in labor force with young children (under 6 years of age)',
              label:
                'two_parents_not_in_labor_force_families_with_young_children',
            },
            {
              name:
                'One-parent families with young children (under 6 years of age)',
              label: 'one_parent_families_with_young_children',
            },
            {
              name:
                'One-parent families, father, with young children (under 6 years of age)',
              label: 'father_one_parent_families_with_young_children',
            },
            {
              name:
                'One-parent families, father in labor force, with young children (under 6 years of age)',
              label:
                'father_in_labor_force_one_parent_families_with_young_children',
            },
            {
              name: 'Number of workers with a commute between 5 and 9 minutes',
              label: 'commute_5_9_mins',
            },
            {
              name: 'Number of workers with less than 10 minute commute',
              label: 'commute_less_10_mins',
            },
            {
              name:
                'Number of workers with a commute between 10 and 14 minutes',
              label: 'commute_10_14_mins',
            },
            {
              name:
                'Number of workers with a commute between 15 and 19 minutes',
              label: 'commute_15_19_mins',
            },
            {
              name:
                'Number of workers with a commute between 20 and 24 minutes',
              label: 'commute_20_24_mins',
            },
            {
              name:
                'Number of workers with a commute between 25 and 29 minutes',
              label: 'commute_25_29_mins',
            },
            {
              name:
                'Number of workers with a commute between 30 and 34 minutes',
              label: 'commute_30_34_mins',
            },
            {
              name:
                'Number of workers with a commute between 35 and 39 minutes',
              label: 'commute_35_39_mins',
            },
            {
              name:
                'Number of workers with a commute between 40 and 44 minutes',
              label: 'commute_40_44_mins',
            },
            {
              name:
                'Number of workers with a commute between 35 and 44 minutes',
              label: 'commute_35_44_mins',
            },
            {
              name:
                'Number of workers with a commute between 45 and 59 minutes',
              label: 'commute_45_59_mins',
            },
            {
              name: 'Number of workers with a commute of over 60 minutes',
              label: 'commute_60_more_mins',
            },
            {
              name:
                'Number of workers with a commute between 60 and 89 minutes',
              label: 'commute_60_89_mins',
            },
            {
              name: 'Number of workers with a commute of over 90 minutes',
              label: 'commute_90_more_mins',
            },
            {
              name: 'Workers age 16 and over who do not work from home',
              label: 'commuters_16_over',
            },
            {
              name: 'Aggregate travel time to work',
              label: 'aggregate_travel_time_to_work',
            },
            {
              name: 'Commuters by Public Transportation',
              label: 'commuters_by_public_transportation',
            },
            {
              name: "Population Completed Associate's Degree",
              label: 'associates_degree',
            },
            {
              name: "Population Completed Bachelor's Degree",
              label: 'bachelors_degree',
            },
            {
              name: 'Population Completed High School',
              label: 'high_school_diploma',
            },
            {
              name:
                'Population completed less than one year of college, no degree',
              label: 'less_one_year_college',
            },
            {
              name: "Population Completed Master's Degree",
              label: 'masters_degree',
            },
            {
              name:
                'Population completed more than one year of college, no degree',
              label: 'one_year_more_college',
            },
            { name: 'Employed Population', label: 'employed_pop' },
            { name: 'Unemployed Population', label: 'unemployed_pop' },
            { name: 'Population in Labor Force', label: 'pop_in_labor_force' },
            {
              name: 'Population Not in Labor Force',
              label: 'not_in_labor_force',
            },
            { name: 'Population in Armed Forces', label: 'armed_forces' },
            {
              name: 'Population in Civilian Labor Force',
              label: 'civilian_labor_force',
            },
          ],
        },
      ],
    },
  },
};
